import {Fragment, useRef, useEffect, useState, useContext} from "react";
//import {  useState } from "react";
import mapMechanical from '../img/map_taller.png';
import { Breadcrumbs, Grid, Link, Tooltip, Typography} from "@mui/material";
import { ShipOnMechanicalComponent } from "./ShipMechanical";
import useWindowDimensions from "../Global/Dimensions";
import {InformationShipComponent} from "./InformationShips";
import {AuthContext} from "../Global/AuthContext";

export const STYLE_IMG={
      top: 0,
      left: 0,
      width: 0,
      height: 0
}




const LEVELS_INIT =[
      {
            text: "Vista General de los talleres",
      }
]

export function MapMechanicalComponent(){

      const [report] = useState([]);
      const imageRef = useRef(null);
      const [imagePosition, setImagePosition] = useState(STYLE_IMG);
      const [machinalSelected, setMechanicalSelected] = useState(null);
      const [shipSelected, setShipSelected] = useState(null);
      const [levels, setLevels] = useState(LEVELS_INIT)
      const { width } = useWindowDimensions();

      useEffect(() => {
            const handleImagePosition = () => {
                  const imageElement = imageRef.current;
                  if (imageElement) {
                        const { top, left, width, height } = imageElement.getBoundingClientRect();
                        setImagePosition({ top, left, width, height });
                  }
            };
        
            // Llama a la función al cargar la página y cada vez que cambie el tamaño de la ventana
            handleImagePosition();
            window.addEventListener('resize', handleImagePosition);
        
            // Limpia el event listener cuando el componente se desmonta
            return () => {
                  window.removeEventListener('resize', handleImagePosition);
            };
      }, []);


      const clickLevels = (level) =>{
            if(level === 0){
                  setLevels(LEVELS_INIT);
                  setMechanicalSelected(null);
                  setShipSelected(null);
            }
            else if(level === 1){
                  setLevels([
                        levels[0],
                        levels[1]
                  ]);
                  setShipSelected(null);
            }
            
      }

      const clickImgMachanical = (name) =>{

            setMechanicalSelected(()=>[{text: name}])

            setLevels(()=>[
                  ...LEVELS_INIT,
                  {text: name}
            ])
      }



      return(
            <Fragment>

                  <Grid container style={{marginBottom: "4vh"}}>
                        <Grid container item xs={12} m={2} alignItems="center" justifyContent="center">
                              <Breadcrumbs>
                                    {
                                          levels.map((rowLevel, index)=>(
                                                <Link underline="hover" color="inherit"
                                                      key={`level-${rowLevel.text.replace(/\s+/g, '-')}`}
                                                      onClick={()=>clickLevels(index)}  >
                                                      <Typography>{rowLevel.text}</Typography>
                                                </Link>
                                          ))
                                    }
                              </Breadcrumbs>
                        </Grid>

                        <Grid container item xs={12} m={2} alignItems="center" justifyContent="center" style={{height: "50vh"}}>
                              <img ref={imageRef}
                                    src={mapMechanical}
                                    alt="ImMapa de los talleres"
                                    style={{
                                                width: width < 600? '100%':'40%',
                                                maxWidth: width < 600? '100%':'75%',
                                                minWidth: width < 600? '100%':'30%',
                                                height: '100%',
                                          }}/>

                              
                              <Tooltip title={
                                  <Fragment>
                                      <Typography>Taller 3</Typography>
                                      <Typography>Capacidad total: 28 | Ocupado: {report.filter((things)=> things?.taller?.label === "Taller 3").length}</Typography>
                                  </Fragment>
                              }>
                                    <div
                                          style={{
                                                position: 'absolute',
                                                top: width < 600? `${imagePosition.top+110}px`:`${imagePosition.top+70}px`,
                                                left: width < 600? `${imagePosition.left+25}px`:`${imagePosition.left+20}px`,
                                                width: width < 600? '10vh':'20vh',
                                                height: width < 600? '12vh':'12vh',
                                                background: 'rgba(0, 0, 0, 0.3)',
                                                cursor: 'pointer',
                                                transform: 'rotate(5deg)',
                                                boxShadow: machinalSelected && machinalSelected[0].text === 'Taller 3'? '0 0 25px rgba(0, 255, 0, 0.9)':'0 0 25px rgba(255, 255, 255, 0.9)',
                                          }}
                                          onClick={() => clickImgMachanical("Taller 3")}
                                          />
                              </Tooltip>

                              <Tooltip title={
                                  <Fragment>
                                      <Typography>Taller 2</Typography>
                                      <Typography>Capacidad total: 26 | Ocupado: {report.filter((things)=> things?.taller?.label === "Taller 2").length}</Typography>
                                  </Fragment>
                              }>
                                    <div
                                          style={{
                                                position: 'absolute',
                                                top: width < 600? `${imagePosition.top+265}px`:`${imagePosition.top+160}px`,
                                                left: width < 600? `${imagePosition.left+140}px`:`${imagePosition.left+165}px`,
                                                width: width < 600? '8vh':'12vh',
                                                height: width < 600? '8vh':'9vh',
                                                background: 'rgba(0, 0, 0, 0.3)',
                                                transform: 'rotate(9deg)',
                                                cursor: 'pointer',
                                                boxShadow: machinalSelected && machinalSelected[0].text === 'Taller 2'? '0 0 25px rgba(0, 255, 0, 0.9)':'0 0 25px rgba(255, 255, 255, 0.9)',
                                          }}
                                          onClick={() => clickImgMachanical("Taller 2")}
                                          />
                              </Tooltip>

                              <Tooltip title={<Typography>Taller 1</Typography>}>
                                    <div
                                          style={{
                                                position: 'absolute',
                                                top: width < 600? `${imagePosition.top+215}px`:`${imagePosition.top+150}px`,
                                                left: width < 600? `${imagePosition.left+225}px`:`${imagePosition.left+260}px`,
                                                width: width < 600?'7vh':'13vh',
                                                height: '25vh',
                                                background: 'rgba(0, 0, 0, 0.3)',
                                                transform: 'rotate(10deg)',
                                                cursor: 'pointer',
                                                boxShadow: machinalSelected && machinalSelected[0].text === 'Taller 1'? '0 0 25px rgba(0, 255, 0, 0.9)':'0 0 25px rgba(255, 255, 255, 0.9)',
                                          }}
                                                // onClick={() => clickImgMachanical("Taller 1")}
                                          />
                              </Tooltip>
                        </Grid>

                        <Grid container item xs={12} spacing={2} justifyContent="center" mt={3} style={{height: "50vh"}}>
                              {
                                    Boolean(machinalSelected)?
                                    <ShipOnMechanicalComponent
                                        selected={machinalSelected[0]}
                                    />:null
                              }
                        </Grid>

                  </Grid>

                  {
                        Boolean(shipSelected)?
                        <InformationShipComponent/>:null
                  }
                  
            </Fragment>
      );
}